import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    heading: 'About this English version',
    body: [
      `English translation of 🇰🇷 코레디 이용약관 (개인회원). Provided for the convenience of Users. The Korean version is the official version — see Supplementary Provisions, Paragraph 3.`,
    ],
  },
  {
    chapter: 'Chapter 1. General Provisions',
    heading: 'Article 1 (Purpose)',
    body: [
      <>
        These Terms set out the conditions and procedures for using the O!ng Lab
        service operated by Oing Lab (brand name &quot;Koready&quot;,
        hereinafter the &quot;Company&quot;) — the website{' '}
        <a
          href='https://www.ko-ready.com'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          www.ko-ready.com
        </a>{' '}
        and all related services (hereinafter the &quot;Service&quot;) — as well
        as the rights, obligations, and responsibilities of the Company and
        Users, and other necessary matters.
      </>,
    ],
  },
  {
    heading: 'Article 2 (Definitions)',
    body: [
      `The terms used in these Terms are defined as follows.`,
      `· "Service" means Korean language learning, Korean cultural experiences, career development, settlement support in Korea, and all related online and offline services that the Company provides for global users.`,
      `· "User" means a Member or non-member who agrees to these Terms and uses the Service.`,
      `· "Member" means a person who has provided personal information to the Company, completed registration, and uses the Service.`,
      `· "Content" means offline workshops, online live sessions, video courses, downloadable materials, view-only materials, bundles, and other paid or free products provided by the Company.`,
      `· "Digital Content" means video courses, downloadable materials, view-only materials, and similar content provided through an information and communications network under the Content Industry Promotion Act and the Act on the Consumer Protection in Electronic Commerce, Etc.`,
      `· "Divisible Digital Content" means Digital Content that consists of multiple lectures or sessions and can therefore be supplied in parts.`,
      `· "Bundle" means a product that combines two or more items of Content.`,
    ],
  },
  {
    heading: 'Article 3 (Effect and Amendment of the Terms)',
    body: [
      `① These Terms take effect when a User agrees to them and uses the Service.`,
      ``,
      `② The Company may amend these Terms within the scope permitted by applicable laws, including the Act on the Regulation of Terms and Conditions, the Act on the Consumer Protection in Electronic Commerce, Etc., the Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc., and the Personal Information Protection Act.`,
      ``,
      `③ When the Company amends these Terms, it will announce the reason and content of the amendment through service notices, email, or website notices — at least 30 days before the effective date if the change is unfavorable to Users, and at least 7 days before the effective date in all other cases.`,
      ``,
      `④ If a User continues to use the Service after the effective date of the amended Terms, the User is deemed to have agreed to them. A User who does not agree may terminate the use contract.`,
    ],
  },
  {
    heading: 'Article 4 (Interpretation and Language of the Terms)',
    body: [
      `① Matters not provided for in these Terms are governed by applicable laws and commercial practice, including the Act on the Regulation of Terms and Conditions, the Act on the Consumer Protection in Electronic Commerce, Etc., the Content Industry Promotion Act, and the Personal Information Protection Act.`,
      ``,
      `② The Company may provide these Terms in languages other than Korean, including English. If the versions conflict, the Korean version prevails. This does not apply where the laws of the User's habitual residence provide otherwise for consumer protection.`,
    ],
  },
  {
    chapter: 'Chapter 2. Use Contract and Account',
    heading: 'Article 5 (Formation of the Use Contract)',
    body: [
      `① The use contract is formed when a User agrees to these Terms and completes registration, or uses the Service.`,
      ``,
      `② The Company may refuse an application or later terminate the use contract in any of the following cases.`,
      `· The registered information contains false statements, omissions, or errors`,
      `· The applicant was previously restricted from use for violating these Terms or for fraudulent use`,
      `· The applicant does not meet other application requirements set by the Company`,
    ],
  },
  {
    heading: 'Article 6 (Eligibility and Age Verification)',
    body: [
      `① The Service is available to persons aged 18 or older.`,
      ``,
      `② The Company restricts registration by persons under 18 through date-of-birth verification at sign-up and maintains technical measures for this purpose.`,
      ``,
      `③ In accordance with Article 22-2 of the Personal Information Protection Act, the Company does not, in principle, collect personal information from children under 14. If the Company becomes aware that a child under 14 has registered, it will destroy the relevant information without delay.`,
    ],
  },
  {
    heading: 'Article 7 (Member Information and Account Management)',
    body: [
      `① Members must enter accurate information in the Service and keep it up to date.`,
      ``,
      `② Members must manage their account and password securely and may not transfer, lend, or share them with others.`,
      ``,
      <>
        ③ If a Member becomes aware of unauthorized use of their account, the
        Member must notify the Company immediately at{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>
        . The Company may temporarily restrict use of the account to protect the
        User or other Users.
      </>,
    ],
  },
  {
    chapter: 'Chapter 3. Provision and Use of the Service',
    heading: 'Article 8 (Description of the Service)',
    body: [
      `The Company provides the following services. Details for each product — schedule, access period, price, refund conditions, and so on — are posted on the product page.`,
      `· Offline workshop — an in-person event held in Korea on a fixed date`,
      `· Online live session — a real-time online session on a fixed date and time`,
      `· Video course — recorded lessons viewed within the Service`,
      `· Downloadable material — files that can be saved to the User's device (for example, PDFs)`,
      `· View-only material — material that can be viewed only within the Service and cannot be downloaded`,
      `· Bundle — a package combining two or more of the products above`,
      `· Career and settlement support tools (Pathfinder and similar)`,
    ],
  },
  {
    heading: 'Article 8-2 (Recruitment Information Services)',
    body: [
      `In addition to the services in Article 8, the Company provides the following recruitment-related services.`,
      `· Searching and viewing job postings registered by Corporate Members`,
      `· Registering and managing a resume`,
      `· Applying to job postings`,
      `· Recommending job postings suited to the User`,
      `· Other services provided by the Company in connection with recruitment and job seeking`,
    ],
  },
  {
    heading: 'Article 8-3 (Status of the Company and Disclaimer of Warranty)',
    body: [
      `① The Company provides a platform for the exchange of information between Users and Corporate Members and is responsible for its operation and management.`,
      ``,
      `② The Company does not act as an agent for Users or Corporate Members and is not a party to any recruitment-related agreement or contract formed between a User and a Corporate Member.`,
      ``,
      `③ The Company does not warrant the truthfulness, accuracy, or lawfulness of information provided by Members, including job postings and company information registered by Corporate Members and resumes registered by Users. Responsibility for such information rests with the Member who registered it.`,
      ``,
      `④ The Company does not guarantee the outcome of a User's application or whether the User will be hired.`,
    ],
  },
  {
    heading: 'Article 9 (Service Hours and Time Zone)',
    body: [
      `① The Service is provided year-round in principle, but may be limited due to the Company's circumstances or the grounds in Article 19.`,
      ``,
      `② Dates and times for offline workshops and online live sessions are shown in Korea Standard Time (KST, UTC+9). Users should check their local time before booking.`,
    ],
  },
  {
    heading: 'Article 10 (User Obligations and Prohibited Conduct)',
    body: [
      `① Users must provide accurate information, use the Service only for personal and lawful purposes, and respect other learners, creators, and staff.`,
      ``,
      `② Users must not engage in any of the following conduct.`,
      `· Sharing an account so that others can use paid Content`,
      `· Copying, recording, downloading (except where permitted), reselling, or externally sharing paid Content without authorization`,
      `· Recording workshops or live sessions without permission`,
      `· Harassing, threatening, or otherwise harming other Users or staff`,
      `· Accessing the Service without authorization using automated tools, or disrupting or damaging the Service`,
      `· Providing false information, impersonating others, or otherwise violating applicable laws or these Terms`,
    ],
  },
  {
    heading: 'Article 11 (Intellectual Property Rights in Content and License)',
    body: [
      `① Copyright and other intellectual property rights in the Service and the Content belong to the Company or the rightful holder.`,
      ``,
      `② By purchasing a product, the User receives a personal, non-transferable license to use it. Users may not reuse, resell, or redistribute the Content, or reproduce or share it outside the Service.`,
    ],
  },
  {
    heading: 'Article 12 (User-Generated Content)',
    body: [
      `① Where a User posts content such as questions or reviews within the Service, copyright in that content belongs to the User.`,
      ``,
      `② The User grants the Company permission to use that content within the Service for the operation and improvement of the Service. The Company may delete content that violates applicable laws or these Terms, or restrict its use.`,
    ],
  },
  {
    heading: 'Article 12-2 (Registration and Provision of Resumes)',
    body: [
      `① Users may register and manage a resume in the Service.`,
      ``,
      `② A resume registered by a User is provided to a Corporate Member only where the User applies to a job posting, and only to the Corporate Member that registered that posting.`,
      ``,
      `③ The Company does not provide any function that allows a Corporate Member to search or view a User's resume without the User's application.`,
      ``,
      `④ The Company may recommend job postings suited to the User based on the User's registered information and activity within the Service.`,
    ],
  },
  {
    heading: 'Article 12-3 (Consent to Application and Submission of Documents)',
    body: [
      `① Users may apply to job postings registered by Corporate Members. When applying, the User submits a resume and other documents designated by the Company (hereinafter "Application Documents").`,
      ``,
      `② Application Documents are shared, for recruitment purposes, with the Corporate Member that registered the relevant job posting.`,
      ``,
      `③ When a User sends an application request, the User is deemed to have agreed to these Terms and the Privacy Policy, and to have consented to the submission and sharing of documents for recruitment purposes. An application cannot proceed without this consent.`,
      ``,
      `④ The Company clearly displays the matters in Paragraphs 2 and 3 where the User can easily see them, such as on the application screen, and provides a procedure for the User to confirm them (for example, a checkbox).`,
      ``,
      `⑤ Users must prepare Application Documents accurately and based on fact. The User is responsible for any consequences arising from false or inaccurate entries.`,
      ``,
      `⑥ The recruitment process after an application — document screening, interviews, hiring decisions, and so on — is conducted by the relevant Corporate Member according to its own criteria and procedures. The Company is not involved in that process.`,
    ],
  },
  {
    heading:
      'Article 12-4 (Viewing Period for Application Documents and Termination of Viewing Rights)',
    body: [
      `① A Corporate Member's right to view Application Documents ends according to the following criteria.`,
      `· If the User is finally hired: up to 90 days from the official start date`,
      `· If the User is not selected: immediately upon the close of the relevant recruitment process`,
      ``,
      `② Once the period in Paragraph 1 has passed, the Company terminates the Corporate Member's viewing rights. The Corporate Member may not continue to hold the Application Documents for recruitment purposes after those rights end. However, where retention is required by applicable laws, the documents may be retained for the period set by those laws.`,
      ``,
      `③ A User may withdraw an application, or withdraw the consent given under Article 12-3, even while a recruitment process is ongoing. In that case the Company terminates the relevant Corporate Member's viewing rights without delay. However, destruction of information already delivered to the Corporate Member follows that Corporate Member's personal information handling standards and applicable laws.`,
    ],
  },
  {
    heading: 'Article 12-5 (Handling of Applicant Information)',
    body: [
      `① A User's resume and Application Documents provided to a Corporate Member through the User's application constitute that Corporate Member's personnel records, and their management follows that Corporate Member's personal information handling standards and applicable laws.`,
      ``,
      `② Corporate Members must use the information they receive only for recruitment or staffing purposes, and may not use it for sales or marketing purposes or provide it to third parties. The Company imposes these obligations on Corporate Members through the Corporate Member Terms of Use.`,
      ``,
      `③ Users may submit inquiries or reports to the Company regarding a Corporate Member's handling of information. After verifying the facts, the Company may take necessary measures, including restricting use, in accordance with the Corporate Member Terms of Use and applicable laws.`,
      ``,
      `④ The Company may view a User's resume information to the extent necessary for operations, such as testing and monitoring for stable service provision and responding to customer inquiries.`,
    ],
  },
  {
    heading: 'Article 12-6 (User Obligations Relating to Applications)',
    body: [
      `① Users must use the Service for the purpose of job seeking and applying for positions.`,
      ``,
      `② Users must not engage in any of the following conduct.`,
      `· Submitting another person's resume, career history, or qualifications as their own`,
      `· Entering false information in a resume or Application Documents`,
      `· Collecting job postings or submitting applications in bulk using automated tools`,
      `· Using information about Corporate Members learned through job postings for purposes other than job seeking, or providing it to third parties`,
      ``,
      `③ If a User violates Paragraph 2 and causes damage to the Company or a Corporate Member, the User is liable for that damage.`,
    ],
  },
  {
    chapter: 'Chapter 4. Paid Services, Payment, and Withdrawal of Subscription',
    heading: 'Article 13 (Paid Services, Prices, and Currency)',
    body: [
      `① Parts of the Service are provided for a fee. Prices are shown in US dollars (USD). If a User selects a Korean card, the price is converted to Korean won (KRW) and the exact KRW amount is shown before payment.`,
      ``,
      `② Korean cards are charged in KRW, and overseas cards and PayPal are charged in USD. Payments are processed through the Company's payment service providers (Toss Payments, PayPal, and others). The Company does not store full card numbers on its own servers.`,
      ``,
      `③ For USD payments, the amount actually received or refunded may differ due to exchange rate changes and payment provider fees. The Company informs Users of this before payment.`,
    ],
  },
  {
    heading:
      'Article 14 (Notice of and Consent to Restrictions on Withdrawal of Subscription)',
    body: [
      `① Users must agree to the refund policy for the relevant product before payment. Payment does not proceed without this agreement.`,
      ``,
      `② In accordance with Article 17(6) of the Act on the Consumer Protection in Electronic Commerce, Etc., the Company clearly displays — where Users can easily see it, such as on the payment screen — that withdrawal of subscription is restricted once the supply of Digital Content such as video courses, downloadable materials, and view-only materials has begun, and provides a procedure for Users to confirm this (for example, a checkbox).`,
    ],
  },
  {
    heading: 'Article 15 (Withdrawal of Subscription and Refunds)',
    body: [
      `① In accordance with Article 17(1) of the Act on the Consumer Protection in Electronic Commerce, Etc., Users may withdraw their subscription within 7 days from the date they receive the written contract terms or from the date the supply of the goods or services begins.`,
      ``,
      `② Withdrawal of subscription may be restricted once the supply of Digital Content has begun. However, for a contract consisting of Divisible Digital Content, withdrawal remains available for the portion whose supply has not begun (for example, lectures not yet viewed).`,
      ``,
      `③ In cases of duplicate payment, fault on the part of the Company, technical error, or where required by applicable laws, the Company will review the refund. Refunds are processed in the currency of payment (KRW or USD).`,
      ``,
      <>
        ④ Specific refund criteria by product type follow the{' '}
        <Link to='/refund-policy' className='underline'>
          refund policy
        </Link>{' '}
        published separately by the Company, and that refund policy forms part
        of these Terms.
      </>,
    ],
  },
  {
    heading:
      'Article 16 (Participation in Workshops and Live Sessions, and No-Shows)',
    body: [
      `① A booking is confirmed when payment is completed. A seat is released if payment is not completed within the payment window (15 minutes). When a session is sold out, the waitlist operates on a first-come, first-served basis, and a notification of an available seat is valid only for a limited time (3 hours).`,
      ``,
      `② If the Company cancels an event, all participants receive a full refund. If the Company changes the schedule, Users may accept the new schedule or receive a full refund.`,
      ``,
      `③ If a User does not attend without prior notice (no-show), or cancels before the event, the Company processes refunds in accordance with the refund rules separately announced, and those rules take precedence over the refund criteria in these Terms. Where no separate refund rules have been announced, refunds are processed according to the following criteria.`,
      `· Up to 48 hours before the scheduled time: 100% of the amount paid is refunded`,
      `· 24 hours or more but less than 48 hours before the scheduled time: 50% of the amount paid is refunded`,
      `· Less than 24 hours before the scheduled time: no refund`,
    ],
  },
  {
    chapter: 'Chapter 5. Protection of Personal Information and Location Information',
    heading: 'Article 17 (Protection of Personal Information)',
    body: [
      <>
        ① The Company protects Users&apos; personal information in accordance
        with applicable laws, including the Personal Information Protection Act.
        Details are set out in the{' '}
        <Link to='/privacy' className='underline'>
          Privacy Policy
        </Link>
        .
      </>,
      ``,
      `② The Company obtains consent separately for items essential to providing the Service and for optional items. Users may refuse optional consent.`,
    ],
  },
  {
    heading: 'Article 18 (Processing of Location Information)',
    body: [
      `① To provide services such as Pathfinder, the Company may collect the country and city of residence and the location of the school that the User enters directly. Use of this information is limited to assessing visa eligibility and providing guidance on settlement pathways in Korea.`,
      ``,
      `② The Company does not carry out automatic location tracking using telecommunications facilities such as GPS, base stations, or Wi-Fi. Accordingly, the above information does not, in principle, constitute personal location information under the Act on the Protection and Use of Location Information.`,
      ``,
      `③ The Company protects the location-related information it collects in accordance with the Personal Information Protection Act and destroys it without delay once the purpose of collection has been achieved.`,
    ],
  },
  {
    heading:
      'Article 18-2 (Provision of Visa Status Information and User Responsibility)',
    body: [
      `① Users may register visa status information in the Service, including status of stay, visa type, date of issue, and expiry date. Users must keep the registered information accurate and update it without delay when it changes.`,
      ``,
      `② Users warrant that they hold the legitimate authority to provide visa status information and must not register false information.`,
      ``,
      `③ Users must independently hold a status of stay that permits employment activity under the Immigration Act. The Company does not warrant whether a User's visa status is eligible.`,
      ``,
      `④ If a User provides false or inaccurate visa status information, or uses the Service under a status of stay that does not permit employment activity, and thereby causes damage to the Company or a third party, the User is liable for that damage.`,
    ],
  },
  {
    chapter: 'Chapter 6. Changes to and Suspension of the Service, and Liability',
    heading: 'Article 19 (Changes to and Suspension of the Service)',
    body: [
      `① The Company may change, temporarily suspend, or discontinue all or part of the Service, and will give advance notice of significant changes. Where paid products are affected, refunds are made in accordance with the refund policy.`,
      ``,
      `② The Service may be temporarily limited in cases of scheduled or emergency maintenance, network or power failures, natural disasters, or other events of force majeure. The Company will give notice before or after such events to the extent possible.`,
    ],
  },
  {
    heading: 'Article 20 (Disclaimer)',
    body: [
      `① To the extent permitted by applicable laws, the Company provides the Service "as is." The Company does not guarantee specific outcomes such as employment, visa issuance, or test scores, and does not guarantee that the Service will always be available without interruption.`,
      ``,
      `② Unless there is intent or gross negligence on its part, the Company is not liable for damage a User suffers in the course of using services or content of other learners, creators, or staff.`,
    ],
  },
  {
    heading: 'Article 21 (Limitation of Liability)',
    body: [
      `① The Company's liability for damages to a User is limited to ordinary direct damages, and the maximum amount is the service fee the User paid directly to the Company in connection with the relevant damage.`,
      ``,
      `② Paragraph 1 does not apply to damages where the Company's intent or gross negligence is objectively established and causation is proven.`,
    ],
  },
  {
    heading: 'Article 22 (Restriction of Use and Termination of Contract)',
    body: [
      `① The Company may restrict use or terminate the contract if a User violates these Terms or interferes with the operation of the Service.`,
      ``,
      `② When restricting use or terminating a contract, the Company will in principle give advance notice of the reason and the method for filing an objection. In urgent or serious cases, notice may be given afterwards.`,
      ``,
      `③ Where a restriction or termination prevents a User from using a paid product already purchased, the Company processes a refund in accordance with the refund policy and applicable laws.`,
      ``,
      `④ Users may stop using the Service and request account deletion (withdrawal of membership) at any time.`,
    ],
  },
  {
    chapter: 'Chapter 7. International Service, Governing Law, and Dispute Resolution',
    heading: 'Article 23 (International Service)',
    body: [
      `The Service may be provided to Users outside the Republic of Korea, and the mandatory laws of those countries may apply. In such cases, the Company may separately provide guidance on matters applicable to the Service in those countries.`,
    ],
  },
  {
    heading: 'Article 24 (Governing Law and Dispute Resolution)',
    body: [
      `① These Terms are interpreted and applied in accordance with the laws of the Republic of Korea.`,
      ``,
      `② If a dispute arises in connection with use of the Service, the parties will make good-faith efforts to resolve it through consultation.`,
      ``,
      `③ Users may use the mediation and counselling services of relevant bodies, including the Consumer Dispute Mediation Committee, the Content Dispute Mediation Committee, and the Personal Information Dispute Mediation Committee (1833-6972).`,
    ],
  },
  {
    chapter: 'Supplementary Provisions',
    heading: 'Effective date and prior versions',
    body: [
      `① These Terms take effect on August 28, 2026.`,
      ``,
      `② The previous Terms of Use in effect before these Terms are replaced by these Terms.`,
      ``,
      `③ This English version is a translation provided for the convenience of Users. The Korean version of these Terms is the official version. In the event of any conflict or difference in interpretation between the Korean and English versions, the Korean version prevails. This does not apply where the laws of the User's habitual residence provide otherwise for consumer protection.`,
      ``,
      <>
        Koready |{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>{' '}
        | Business Registration No. 179-45-01005
      </>,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: 'Terms of Use',
  lastUpdated: 'August 28, 2026',
  effectiveDate: '2026-08-28',
  sections,
};
